import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../store';
import { logDwFailure } from '../../Utils/validations-utils';
import { flowType } from './user';

interface ModuleState {
  error: string[];
}

interface DwLogsState {
  [key: string]: ModuleState | string[] | undefined;
  failedModules: string[];
}

const isProd = process.env.REACT_APP_ENV === 'production';

const initialState: DwLogsState = {
  failedModules: [],
};

const dwLogsSlice = createSlice({
  name: 'dwLogs',
  initialState,
  reducers: {
    setModuleFailure(state, action: PayloadAction<{ key: string; error: string }>) {
      const { key, error } = action.payload;

      if (!state[key] || !Array.isArray((state[key] as ModuleState).error)) {
        state[key] = { error: [error] };
      } else {
        (state[key] as ModuleState).error.push(error);
      }

      if (!state.failedModules.includes(key)) {
        state.failedModules.push(key);
      }
    },

    clearFailedModules(state) {
      state.failedModules = [];
    },
  },
});

export const handleModuleFailure =
  (key: string, error: string,flowType: string) =>
  (dispatch: AppDispatch, getState: () => RootState) => {
    const { dwLogsReducer: dwLogs } = getState();
    const module = dwLogs[key] as ModuleState | undefined;
    const alreadyLogged = module?.error?.includes(error) ?  true : false;

    dispatch(dwLogsSlice.actions.setModuleFailure({ key, error }));

    if (key) {
      logDwFailure(key, error,flowType);
    }
  };

export const { setModuleFailure, clearFailedModules } = dwLogsSlice.actions;
export default dwLogsSlice.reducer;
